const TOKEN_KEY = "token"

const storage = () =>
  typeof window === "undefined" ? undefined : sessionStorage

export const getLegacyAuthToken = () => {
  const token = storage()?.getItem(TOKEN_KEY) || null
  if (typeof window !== "undefined") localStorage.removeItem(TOKEN_KEY)
  return token
}

export const setLegacyAuthToken = (token?: string | null) => {
  if (typeof window !== "undefined") localStorage.removeItem(TOKEN_KEY)
  if (token) storage()?.setItem(TOKEN_KEY, token)
  else storage()?.removeItem(TOKEN_KEY)
}

export const clearLegacyAuthToken = () => setLegacyAuthToken(null)
